import React, { useEffect, useState, useCallback } from 'react';
import EventParticipationTable from './EventParticipationTable';
import PropTypes from 'prop-types';
import LoadingContent from 'components/NewDesign/LoadingContent';
import { toast } from 'react-toastify';
import { getEventParticipationReport } from 'api/reportsApi';

const EventParticipation = ({ clubID, onDataChange, pointsEligibleOnly, onMeetScopeChange }) => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchEventParticipation = useCallback(async () => {
    try {
      if (clubID) {
        setLoading(true);
        const response = await getEventParticipationReport(clubID, pointsEligibleOnly);
        const data = response.data || {};
        setReportData(data);
      }
      setLoading(false);
    } catch (err) {
      console.error('[EventParticipation] Fetch event participation error: ', err);
      toast.error('Failed to load event participation report');
      setLoading(false);
    }
  }, [clubID, pointsEligibleOnly]);

  useEffect(() => {
    if (clubID) {
      fetchEventParticipation();
    }
  }, [fetchEventParticipation, clubID]);

  // Notify parent component of data changes (for export button)
  useEffect(() => {
    if (onDataChange) {
      onDataChange({
        hasData: reportData?.eventParticipationStats?.length > 0,
        season: reportData?.season,
      });
    }
  }, [reportData, onDataChange]);

  return (
    <>
      <LoadingContent loading={loading}>
        <EventParticipationTable
          eventParticipationStats={reportData?.eventParticipationStats || []}
          season={reportData?.season}
          pointsEligibleOnly={pointsEligibleOnly}
          onMeetScopeChange={onMeetScopeChange}
        />
      </LoadingContent>
    </>
  );
};

EventParticipation.propTypes = {
  clubID: PropTypes.string,
  onDataChange: PropTypes.func,
  pointsEligibleOnly: PropTypes.bool,
  onMeetScopeChange: PropTypes.func,
};

export default EventParticipation;
